/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceGroupEmployeeUsageLineChartQueryVariables = Types.Exact<{
  clientApplicationId: Types.Scalars['UUID']['input'];
  dateFrom?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  dateTo?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type ResourceGroupEmployeeUsageLineChartQuery = { __typename: 'Query', resourceGroupUsage?: Array<{ __typename: 'ResourceGroupUsageType', date: any, resourceGroupId?: string | null, totalEventCount: number, applicationCount: number, employeeCount: number } | null> | null };



export const ResourceGroupEmployeeUsageLineChartDocument = `
    query ResourceGroupEmployeeUsageLineChart($clientApplicationId: UUID!, $dateFrom: Date, $dateTo: Date) {
  resourceGroupUsage(
    clientApplicationId: $clientApplicationId
    dateFrom: $dateFrom
    dateTo: $dateTo
    includeBreakdown: false
  ) {
    date
    resourceGroupId
    totalEventCount
    applicationCount
    employeeCount
  }
}
    `;

export const useResourceGroupEmployeeUsageLineChartQuery = <
      TData = ResourceGroupEmployeeUsageLineChartQuery,
      TError = unknown
    >(
      variables: ResourceGroupEmployeeUsageLineChartQueryVariables,
      options?: Omit<UseQueryOptions<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>(
      {
    queryKey: ['ResourceGroupEmployeeUsageLineChart', variables],
    queryFn: fetcher<ResourceGroupEmployeeUsageLineChartQuery, ResourceGroupEmployeeUsageLineChartQueryVariables>(ResourceGroupEmployeeUsageLineChartDocument, variables),
    ...options
  }
    )};

useResourceGroupEmployeeUsageLineChartQuery.getKey = (variables: ResourceGroupEmployeeUsageLineChartQueryVariables) => ['ResourceGroupEmployeeUsageLineChart', variables];

export const useInfiniteResourceGroupEmployeeUsageLineChartQuery = <
      TData = InfiniteData<ResourceGroupEmployeeUsageLineChartQuery>,
      TError = unknown
    >(
      variables: ResourceGroupEmployeeUsageLineChartQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceGroupEmployeeUsageLineChartQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ResourceGroupEmployeeUsageLineChart.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceGroupEmployeeUsageLineChartQuery, ResourceGroupEmployeeUsageLineChartQueryVariables>(ResourceGroupEmployeeUsageLineChartDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceGroupEmployeeUsageLineChartQuery.getKey = (variables: ResourceGroupEmployeeUsageLineChartQueryVariables) => ['ResourceGroupEmployeeUsageLineChart.infinite', variables];


useResourceGroupEmployeeUsageLineChartQuery.fetcher = (variables: ResourceGroupEmployeeUsageLineChartQueryVariables) => fetcher<ResourceGroupEmployeeUsageLineChartQuery, ResourceGroupEmployeeUsageLineChartQueryVariables>(ResourceGroupEmployeeUsageLineChartDocument, variables);
